module.exports = __webpack_public_path__ + "static/media/cancelIcon.28dcf314.svg";